import InductionPolicy from "./InductionPolicy";

export default InductionPolicy;
